import React from 'react';

export const DKPopupContent = ({ setShowForm }: { setShowForm: (showForm: boolean) => void }) => (
  <>
    <div>
      <h2 className="text-3xl mt-12 font-semibold text-gray-900">
        Boost your business with proven solutions that deliver real results.
      </h2>

      <p className="text-lg text-gray-600 mt-8">
        Apply by March 31, 2025, to claim your $500 discount – only for PayBlox merchants!
      </p>

      <h3 className="text-2xl font-semibold text-gray-900 mt-40">Featured Services:</h3>

      <div className="grid grid-cols-2 gap-24 mt-24">
        <div className="flex items-start gap-16">
          <div className="text-gray-700 mt-1">
            <img src="/assets/icons/gallery.svg" alt="gallery" className="icon" />
          </div>
          <div className="gap-4">
            <h4 className="text-lg font-semibold text-gray-900">High-Converting Landing Pages</h4>
            <p className="text-gray-500">Scale your business with data-driven designs.</p>
          </div>
        </div>

        <div className="flex items-start gap-16">
          <div className="text-gray-700 mt-1">
            <img src="/assets/icons/ai_line.svg" alt="ai_line" className="icon" />
          </div>
          <div className="gap-4">
            <h4 className="text-lg font-semibold text-gray-900">AI-Enhanced UX/UI Solutions</h4>
            <p className="text-gray-500">Prioritize user experience for better results.</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-24 mt-24">
        <div className="flex items-start gap-16">
          <div className="text-gray-700 mt-1">
            <img src="/assets/icons/document-text.svg" alt="document-text" className="icon" />
          </div>
          <div className="gap-4">
            <h4 className="text-lg font-semibold text-gray-900">Comprehensive QA Testing</h4>
            <p className="text-gray-500">Launch with confidence and peace of mind.</p>
          </div>
        </div>

        <div className="flex items-start gap-16">
          <div className="text-gray-700 mt-1">
            <img
              src="/assets/icons/programming-arrows.svg"
              alt="programming-arrows"
              className="icon"
            />
          </div>
          <div className="gap-4">
            <h4 className="text-lg font-semibold text-gray-900">Custom Business Automation</h4>
            <p className="text-gray-500">Maximize efficiency with smart workflows.</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-24 mt-24">
        <div className="flex items-start gap-16">
          <div className="text-gray-700 mt-1">
            <img src="/assets/icons/money-3.svg" alt="money-3" className="icon" />
          </div>
          <div className="gap-4">
            <h4 className="text-lg font-semibold text-gray-900">Seamless Checkout Integration</h4>
            <p className="text-gray-500">Optimize your payment experience.</p>
          </div>
        </div>
      </div>
    </div>
    <div className="flex justify-start mt-40">
      <button
        className="bg-blue-primary hover:bg-blue-primary-hover text-white font-[400] px-[16px] py-[7px] rounded-full text-lg"
        onClick={() => setShowForm(true)}
      >
        Apply Now and Save $500!
      </button>
    </div>
  </>
);
